import customDownloadElement from '@assets/css/custom-download-element.css';

/**
 * Custom download element styles.
 * @type {CSSStyleSheet}
 */
export const customDownloadElementStyles = new CSSStyleSheet();
customDownloadElementStyles.replaceSync(customDownloadElement);
